import { useEffect, useRef, useState } from 'react';
import { googleSession } from '../api/api';
import { getStoredFirstVisit } from '../context/AuthContext';

const LOGGED_IN_KEY = 'karmana_user_logged_in';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      window.location.replace('/');
      return;
    }

    const ft = getStoredFirstVisit();
    googleSession({
      session_id: sessionId,
      first_time_user_type: ft?.user_type,
      first_time_location: ft?.location,
    })
      .then(() => {
        localStorage.setItem(LOGGED_IN_KEY, '1');
        // Check for a pending "Interested" intent saved before the OAuth redirect.
        let redirectTo = '/my-impact';
        try {
          const pending = JSON.parse(localStorage.getItem('karmana_pending_interest') || 'null');
          if (pending?.activityId && pending?.returnPath) {
            localStorage.removeItem('karmana_pending_interest');
            redirectTo = `${pending.returnPath}?autoInterest=${pending.activityId}`;
          }
        } catch { /* ignore */ }
        // Check for a pending changemaker like
        if (redirectTo === '/my-impact') {
          try {
            const pendingLike = JSON.parse(localStorage.getItem('karmana_pending_like_changemaker') || 'null');
            if (pendingLike?.changemakerId && pendingLike?.returnPath) {
              localStorage.removeItem('karmana_pending_like_changemaker');
              redirectTo = `${pendingLike.returnPath}?autoLikeChangemaker=${pendingLike.changemakerId}`;
            }
          } catch { /* ignore */ }
        }
        // Full reload so AuthProvider re-checks the session cookie.
        window.location.replace(redirectTo);
      })
      .catch(() => {
        setError(true);
        setTimeout(() => window.location.replace('/'), 1500);
      });
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50" data-testid="auth-callback">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      <p className="mt-4 text-gray-600">
        {error ? 'Sign-in failed. Redirecting…' : 'Signing you in…'}
      </p>
    </div>
  );
};

export default AuthCallback;
